import React, { memo, useCallback, useState, useEffect, useRef } from "react";

import ReactDOM from "react-dom";
import styles from "./modal.module.css";

function ModalImage({ isShowing, hide, imagem }) {
  const [show, setShow] = useState(isShowing);
  const [notShow, setNotShow] = useState(!isShowing);

  const timeRef = useRef(null);

  useEffect(() => {
    if (isShowing) {
      setShow(true);

      setNotShow(false);
      clearTimeout(timeRef.current);
    } else {
      setShow(false);
      timeRef.current = setTimeout(() => setNotShow(true), 800);
    }
  }, [isShowing]);

  /* unmount cleanup */
  useEffect(() => () => clearTimeout(timeRef.current), []);

  const modalRef = useRef();

  const handleClose = useCallback((e) => {
    if (e.target === modalRef.current) {
      hide();
    }
  }, []);

  return !notShow
    ? ReactDOM.createPortal(
        <React.Fragment>
          <div
            className={`${!show && styles.hidden} ${styles.modalGeral}`}
            ref={modalRef}
            onClick={handleClose}
          >
            <div className={styles.modalBox}>
              <div onClick={() => hide()} className={styles.modalClose}>
                <img src="/icons/close.svg" alt="fechar" />
              </div>
              <div className={styles.modalImg}>
                <img src={imagem} />
              </div>
            </div>
          </div>
        </React.Fragment>,
        document.body
      )
    : null;
}

export default memo(ModalImage);
